module.exports = __webpack_public_path__ + "img/2.0fc93ed8.png";